import { AxiosError } from 'axios';

import { ApiError } from '@/types';

// Single source of truth for turning a failed request into a user-facing string:
// prefers the API envelope's `message`, falling back to a caller-supplied line
// for transport errors (no response). Used by the auth pages and the dashboard
// so the error-envelope shape lives in one place.
//
// A 422 from validate() always carries the same opaque message ('Validation
// failed') with the real cause only in `errors[]`, so those field messages are
// appended - otherwise an invalid configured sender address surfaced to the RM
// as an unactionable "Validation failed" with nothing naming the field.
export const errorMessage = (error: unknown, fallback: string): string => {
  const data = (error as AxiosError<ApiError>).response?.data;
  if (!data?.message) return fallback;
  const fields = data.errors?.map((e) => (e.field ? `${e.field}: ${e.message}` : e.message)) ?? [];
  return fields.length > 0 ? `${data.message} - ${fields.join('; ')}` : data.message;
};
